import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { useState, useEffect, useCallback } from 'react';
import { StyledAccordion, StyledAccordionItem } from './Accordion.styles.js';
import { AccordionType } from './Accordion.types.js';
import { useDesignSystemThemeName } from '../utils.js';
import { ChevronDownOutline16 } from '../../icons/16/index.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var AccordionItem = function AccordionItem(_ref) {
  var darkMode = _ref.darkMode,
      item = _ref.item,
      open = _ref.open,
      toggleOpen = _ref.toggleOpen,
      type = _ref.type;
  var handleClick = useCallback(function (event) {
    var _item$onClick;

    (_item$onClick = item.onClick) === null || _item$onClick === void 0 ? void 0 : _item$onClick.call(item, event, _objectSpread(_objectSpread({}, item), {}, {
      open: open
    }));

    if (!event.defaultPrevented) {
      toggleOpen(item);
    }
  }, [item, open, toggleOpen]);
  var handleKeyPress = useCallback(function (event) {
    var _item$onKeyPress;

    if (event.key !== 'Enter') return;
    (_item$onKeyPress = item.onKeyPress) === null || _item$onKeyPress === void 0 ? void 0 : _item$onKeyPress.call(item, event, _objectSpread(_objectSpread({}, item), {}, {
      open: open
    }));

    if (!event.defaultPrevented) {
      toggleOpen(item);
    }
  }, [item, open, toggleOpen]);
  return /*#__PURE__*/React__default.createElement(StyledAccordionItem, {
    className: "\n        accordion-item\n        ".concat(item.disabled ? 'accordion-item-disabled' : '', "\n        ").concat(open ? 'accordion-open' : 'accordion-closed', "\n      "),
    darkMode: Boolean(darkMode),
    disabled: Boolean(item.disabled),
    key: item.id,
    "data-test-id": item['data-test-id']
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "accordion-button ".concat(type ? "".concat(type) : ''),
    role: "button",
    "aria-expanded": open,
    "aria-disabled": item.disabled,
    onClick: handleClick,
    onKeyPress: handleKeyPress,
    tabIndex: item.disabled ? -1 : 0
  }, item.title, /*#__PURE__*/React__default.createElement("span", {
    role: "img",
    "aria-hidden": true,
    className: "accordion-item-arrow"
  }, /*#__PURE__*/React__default.createElement(ChevronDownOutline16, {
    style: {
      transitionDuration: '0.3s',
      transform: "rotate(".concat(open ? '180' : '360', "deg)")
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "accordion-content ".concat(open ? 'open' : 'closed')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "accordion-content-box  ".concat(type ? "".concat(type) : ''),
    role: "region"
  }, item.content)));
};

var getItemOpenState = function getItemOpenState(items) {
  return items.reduce(function (acc, item) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, item.id, !!item.open));
  }, {});
};

var Accordion = function Accordion(props) {
  var darkMode = props.darkMode,
      type = props.type,
      multiOpen = props.multiOpen,
      dataTestId = props['data-test-id'],
      items = props.items;
  var themeName = useDesignSystemThemeName();

  var _useState = useState(getItemOpenState(items)),
      _useState2 = _slicedToArray(_useState, 2),
      itemOpenState = _useState2[0],
      setItemOpenState = _useState2[1];

  useEffect(function () {
    setItemOpenState(getItemOpenState(items));
  }, [items]);
  var handleToggleOpen = useCallback(function (selectedItem) {
    if (selectedItem.disabled) {
      return;
    }

    if (multiOpen) {
      setItemOpenState(function (current) {
        return _objectSpread(_objectSpread({}, current), {}, _defineProperty({}, selectedItem.id, !current[selectedItem.id]));
      });
    } else {
      setItemOpenState(function (current) {
        var ids = Object.keys(current);
        return ids.reduce(function (acc, id) {
          if (id === selectedItem.id) {
            acc[id] = !current[id];
          } else {
            acc[id] = false;
          }

          return acc;
        }, {});
      });
    }
  }, [multiOpen]);

  if (!(items !== null && items !== void 0 && items.length)) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(StyledAccordion, {
    className: "\n          accordion\n          ".concat(darkMode ? 'accordion-dark' : '', "\n          ").concat(themeName, "\n        "),
    "data-test-id": dataTestId
  }, items.map(function (item, i) {
    return /*#__PURE__*/React__default.createElement(AccordionItem, {
      darkMode: darkMode,
      item: item,
      key: i,
      open: itemOpenState[item.id],
      type: type,
      toggleOpen: handleToggleOpen
    });
  }));
};

Accordion.defaultProps = {
  'data-test-id': 'Accordion',
  items: [],
  darkMode: false,
  type: AccordionType.DEFAULT,
  multiOpen: false
};

export { Accordion, Accordion as default };
//# sourceMappingURL=Accordion.js.map
